'use client';

import DesktopLeftSideStep from '@/components/DesktopLeftSideStep';
import { stepDescriptionsEn, stepDescriptionsIt } from '@/components/leftSide';
import { LocaleType } from '@/i18n/routing';
import ClientLayoutDesktopBottom from '../layout_client_desktop_bottom';
import star from '@/assets/images/filigrana/star.svg';
import Image from 'next/image';
import { Quote } from '@/components/Quote';
import QuestionTransitionEffect from '@/components/transitions/QuestionTransitionEffect';
import { ConfigSlim } from '@/types/configuration';

export type DescriptionType = {
    title: string;
    description: string;
    description2?: string;
    description3?: string;
};

type Props = {
    appEnv: string
    locale: LocaleType
    tenant: string
    children: React.ReactNode;
    initialDescription: DescriptionType;
    texts: any;
    configInfo: ConfigSlim;
};

const ClientLayoutWrapper = ({ appEnv, children, initialDescription, texts, locale, tenant, configInfo }: Props) => {

    console.log("REFRESH of ClientLayoutWrapper");


    const stepDescriptions = locale === 'it' ? stepDescriptionsIt : stepDescriptionsEn;

    return (
        <section className="h-full flex flex-col lg:grid lg:grid-cols-12 gap-0 relative min-h-screen lg:min-h-full">
            <DesktopLeftSideStep
                appEnv={appEnv}
                texts={texts.desktopLeftSideStep}
                locale={locale}
                uiConfig={configInfo.uiConfig}
                tenant={tenant}
                initialDescription={initialDescription}
                stepDescriptions={stepDescriptions} />
            <div className="col-span-12 lg:col-span-8 flex grow flex-col justify-around lg:justify-between z-10">
                <section className="px-5 pt-10 lg:px-12 h-full w-full flex flex-col max-w-[48rem] mx-auto justify-center " >
                    {/* <div className='w-full  text-center lg:text-left'> */}
                    <QuestionTransitionEffect>{children}</QuestionTransitionEffect>
                    {/* </div> */}
                </section>
                <ClientLayoutDesktopBottom texts={texts} tenant={tenant} locale={locale} configInfo={configInfo} />
                <div className='lg:hidden px-5 mb-24'>
                    <Quote locale={locale} />
                </div>
            </div>
            {
                !configInfo.draftMode ? null : <> <div className='text-3xl text-[#14328F] top-[30%] left-[0%] opacity-100 absolute transform rotate-[-45deg]'>
                    DRAFT&nbsp;-&nbsp;DRAFT&nbsp;-&nbsp;DRAFT
                </div>
                    <div className='text-2xl text-[#14328F] top-[50%] left-[30%] opacity-100 absolute transform rotate-[-45deg]'>
                        DRAFT&nbsp;-&nbsp;DRAFT&nbsp;-&nbsp;DRAFT&nbsp;-&nbsp;DRAFT&nbsp;-&nbsp;DRAFT&nbsp;-&nbsp;DRAFT
                    </div>
                    <div className='text-2xl text-[#14328F] top-[80%] left-[50%] opacity-100 absolute transform rotate-[-45deg]'>
                        DRAFT&nbsp;-&nbsp;DRAFT&nbsp;-&nbsp;DRAFT
                    </div></>
            }
        </section>
    );
};

export default ClientLayoutWrapper;
